import { graphql } from "babel-plugin-relay/macro";
export const QUERY = graphql`
    query answersStatisticsTable_Query(
        $filterByTitle: String
        $greaterThanDate: ZonedDateTIme
        $lessThanDate: ZonedDateTIme
        $filterByTagIds: [ID!]
    ) {
        ...answersStatisticsTable_Fragment   
        @arguments(
            filterByTitle: $filterByTitle,
            greaterThanDate: $greaterThanDate,
            lessThanDate: $lessThanDate,
            filterByTagIds: $filterByTagIds
        )
    }
`
export const ANSWERS_STATISTIC_FRAGMENT = graphql`
    fragment answersStatisticsTable_Fragment on Query
    @refetchable(queryName: "answersStatisticsTable_Refetch")
    @argumentDefinitions(
        first: { type: "Int", defaultValue: 1 }
        after: { type: "String" }
        filterByTitle: { type: "String" }
        greaterThanDate: { type: "ZonedDateTIme" }
        lessThanDate: { type: "ZonedDateTIme" }
        filterByTagIds: {type: "[ID!]"}
    ) {
        Admin {
            Statistic {
                AnswersStatistic(first: $first, after: $after, filterByTitle: $filterByTitle, greaterThanDate: $greaterThanDate, lessThanDate: $lessThanDate, filterByTagIds: $filterByTagIds)
                @connection(key: "answersStatisticsTable_AnswersStatistic"){
                    edges {
                        node {
                            rootNodeId
                            rootNodeTitle
                            elementStatistics {
                                elementId
                                question
                                totalTries
                                correctPercentage
                                answerStatistics {
                                    checkedTimes
                                    index
                                    isCorrect
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
